/**
 * 共享格式化工具函数
 */

/** 数字格式化（千分位分隔） */
export function formatNumber(n) {
  if (n == null) return '-'
  return Number(n).toLocaleString('zh-CN')
}

/** 文件大小格式化 */
export function formatSize(bytes) {
  if (!bytes) return '0 B'
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
  return (bytes / (1024 * 1024 * 1024)).toFixed(1) + ' GB'
}

/** GB 格式化 */
export function formatGB(bytes) {
  if (!bytes) return '0'
  return (bytes / (1024 ** 3)).toFixed(1)
}

/**
 * 自适应容量：不足 1 GB 时按 MB/KB 显示。
 *
 * 2026-10-27：工作台用 formatGB 显示已用空间，8.8 MB 被显示成「0.0 GB」，
 * 同一格里又写着「逻辑 8.8 MB · 物理 9.9 MB」，自相矛盾。
 * 配额上限仍用 GB（那是"10 GB 套餐"这种整数），只有已用量需要自适应。
 */
export function formatCapacity(bytes) {
  if (!bytes) return '0 B'
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  if (bytes < 1024 ** 3) return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
  return (bytes / (1024 ** 3)).toFixed(1) + ' GB'
}

/** 日期格式化 */
export function formatDate(iso) {
  if (!iso) return '-'
  return new Date(iso).toLocaleString('zh-CN', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit',
  })
}

/** 短日期格式化（如 "9月5日"），无效日期返回空串 */
export function formatShortDate(iso) {
  if (!iso) return ''
  try {
    const d = new Date(iso)
    if (isNaN(d.getTime())) return ''
    return `${d.getMonth() + 1}月${d.getDate()}日`
  } catch {
    return ''
  }
}

/** 仅日期格式化（如 "2026/09/05"） */
export function formatDateOnly(iso) {
  if (!iso) return '-'
  return new Date(iso).toLocaleDateString('zh-CN', {
    year: 'numeric', month: '2-digit', day: '2-digit',
  })
}

/** 角色中文映射 */
export const ROLE_LABELS = {
  owner: '企业主',
  admin: '管理员',
  editor: '编辑者',
  viewer: '成员',
  member: '成员', // legacy
}

/** BMI 维度名称映射 */
export const BMI_DIMENSION_NAMES = {
  density: '记忆密度',
  visibility: '可见度',
  compound: '时间复利',
}

/** 事实类型中文映射 */
export const FACT_TYPE_LABELS = {
  title: '标题',
  description: '描述',
  tag: '标签',
  color: '颜色',
  material_type: '材质',
  material: '材质',
  scene: '场景',
  style: '风格',
  usage_suggestion: '使用建议',
  entity: '实体',
  channel_fit: '渠道适配',
  seo_keyword: 'SEO 关键词',
  topic: '主题',
  brand_voice: '品牌调性',
  other: '其他',
}

/** 搜索匹配类型映射 */
export const MATCH_TYPE_LABELS = {
  semantic: '语义匹配',
  keyword: '关键词',
  bm25: '全文检索',
  vector: '向量匹配',
  expanded: '扩展词',
  rerank: '重排序',
  similar: '视觉相似',
}

/** 搜索意图中文映射 */
export const INTENT_LABELS = {
  semantic: '语义搜索',
  find_similar: '相似查找',
  browse: '浏览',
  compare: '对比',
  filter: '筛选',
}

/** 搜索筛选键中文映射 */
export const FILTER_KEY_LABELS = {
  file_type: '文件类型',
  status: '状态',
  date: '日期',
  tag: '标签',
}

/** 文件类型中文映射 */
export const FILE_TYPE_LABELS = {
  image: '图片',
  video: '视频',
  document: '文档',
  audio: '音频',
  other: '其他',
}
